import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import InputAdornment from "@material-ui/core/InputAdornment";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import BookmarkBorder from "@material-ui/icons/BookmarkBorder";
import Check from "@material-ui/icons/Check";
import SaveIcon from '@material-ui/icons/Save';
import ViewList from "@material-ui/icons/ViewList";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle.jsx";
import AlertInfo from "components/AlertInfo/AlertInfo.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
// core components
import Button from "components/CustomButtons/Button.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
// module components
import WaitDialog from "modules/components/WaitDialog.jsx";
import { configureTypeNewness, getTypeNewnessById, setTypeNewness} from 'modules/configurations/type_newness/TypeNewnessActions';
import React from "react";
import { connect } from 'react-redux';
import { Redirect } from "react-router-dom";

const style = {
  gridContainer: {
    padding: "0px 30px 30px 40px"
  }

  , gridItem: {
    margin: "20px 0px 10px 0px"
  }

  , headerGridItem: {
    margin: "30px 0px 0px 0px"
  }
  , ...regularFormsStyle
};

class ChangePasswordAdmin extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      checked: [0],
      openAlertInfo: false,
      textAlertInfo: "",


      userId: sessionStorage['userSystemId'],
      password: '',
      newPassword: '',
      confirmPassword: '',

      redirectAdmin: false,

      textChangePass: "",
      openAlertChangePass: false,
    };

  }


  setPasswords(e)
  {
    var state = this.state;
    state[e.target.name] = e.target.value;
    this.setState({ state })
  }


  changePassword = ()=>
  {
    const {password, newPassword, confirmPassword, userId} = this.state
    
    if(password == '' || newPassword == '' || confirmPassword == '') {
      this.showAlertInfo('Debes completar todos los campos')
    }

    else if(newPassword != confirmPassword) {
      this.showAlertInfo('Las contraseñas no coinciden')
    }

    else {
      var datos = {
        userId: userId,
        password: password, 
        newPassword: newPassword,
        confirmPassword: confirmPassword
      }

      // Cambiar IP
      fetch("http://44.227.228.174:8080/lucy-account-services/user/changePassword", {
        method: "POST",
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(datos)
      })
      .then(resp => resp.json())
      .then(resp =>
      {

        if(resp.apiResponse.code == 200)
        {
          // show alert
          this.setState({
            openAlertChangePass: true,
            textChangePass: 'Contraseña cambiada exitosamente!'
          });
        }
        else
        {
          this.showAlertInfo(resp.apiResponse.message)
        }
      })
      // .then(resp => 
      // {
      //   console.log(resp)

      //   // get expiration time
      //   // let accountId = sessionStorage.getItem('accountId')
      //   // let accountCode = sessionStorage.getItem('accountCode')

      //   // let url = 'https://lucyvirtualassistant.com:8443/lucy-account-services/expirationTime/get/'+accountCode?idAccount='+accountId;

      //   const accountId = sessionStorage.getItem('accountId');
      //   const accountCode = sessionStorage.getItem('accountCode');

      //   const url = `https://lucyvirtualassistant.com:8443/lucy-account-services/passwordChangeTime/get/${accountCode}`;

      //   fetch(url)
      //   .then(resp2 => resp2.json())
      //   .then(resp2 =>  
      //   { 

      //     if(resp2.status == 200)
      //     {
      //       sessionStorage['expirationTime'] = resp2.ExpirationTime
      //     }
      //     else
      //     {
      //       sessionStorage['expirationTime'] = 10
      //     }


      //     // show alert
      //     this.setState({
      //       openAlertChangePass: true,
      //       textChangePass: 'Contraseña cambiada exitosamente!'
      //     });
          
      //   })
      //   .then(console.log)

      // })
      .catch(console.log)
    }
  }


  redirectAccount = () => 
  {
    this.setState({
      openAlertChangePass: false
    });

    this.setState({ redirectAdmin: true });
  }


  // componentDidMount = () => {
  //   var urlParams = new URLSearchParams(this.props.location.search);
  //   if (urlParams.has('code')) {
  //     this.props.getTypeNewnessById(urlParams.get('code'));
  //   }
  // }


  configureTypeNewness = () => {
    const { typeNewness } = this.props.typeNewnessState.data;

    if (typeNewness.serviceName === "") {

      this.showAlertInfo("Por favor debe ingresar el nombre de la novedad");
      return;
    }


    this.props.configureTypeNewness(typeNewness, this.props, (success) => {
      //Navegación a la lista
      this.props.history.push('/admin/config-type-newness');
    });
  }

  showAlertInfo = (text) => {
    this.setState({
      openAlertInfo: true,
      textAlertInfo: text,
    });
  }

  hideaAlertInfo = () => {
    this.setState({
      openAlertInfo: false
    });
  }

  handleInputText = event => {
    var typeNewness = this.props.typeNewnessState.data.typeNewness;
    typeNewness[[event.target.name]] = event.target.value;
    this.props.setTypeNewness(typeNewness);
  };

  handleToggle() {
    var typeNewness = this.props.typeNewnessState.data.typeNewness;
    if (typeNewness.active) {
      typeNewness.active = 0;
    } else {
      typeNewness.active = 1;
    }
    this.props.setTypeNewness(typeNewness);
  }

  handlePriorityInput = event => {
    var typeNewness = this.props.typeNewnessState.data.typeNewness;
    typeNewness[[event.target.name]] = event.target.value;
    this.props.setTypeNewness(typeNewness);
  }

  render() {
    

    if (this.state.redirectAdmin === true) {
      return <Redirect to={'/admin'} />
    }


    const { classes } = this.props;
    let isActivityIndicatorShown = this.props.typeNewnessState.data.isActivityIndicatorShown;
    const { typeNewness } = this.props.typeNewnessState.data;


    const {password, newPassword, confirmPassword} = this.state;


    return (
      <GridItem xs={12}>
        {isActivityIndicatorShown &&
          <WaitDialog text={this.state.textAlertInfo} />
        }
        
        <AlertInfo text={this.state.textAlertInfo} open={this.state.openAlertInfo} onDoneClick={this.hideaAlertInfo} />
        

        <AlertInfo text={this.state.textChangePass} open={this.state.openAlertChangePass} onDoneClick={this.redirectAccount} />


        <Card>
          <CardHeader color="info" icon>
            <CardIcon color="info">
              <ViewList />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Nueva Contraseña</h4>
          </CardHeader>
          <CardBody>
            <GridContainer>
              <GridItem xs={12} sm={12}>
                <GridItem xs={12} sm={12}>
                  <h4 className={classes.infoText}>

                  </h4>
                </GridItem>

                <GridItem xs={12} sm={12}>
                  
                  
                  <CustomInput
                    labelText={
                      <span>
                        Contraseña Actual
                        </span>
                    }
                    id="password"
                    formControlProps={{
                      fullWidth: true
                    }}

                    inputProps={{
                      name: "password",
                      id: "password",

                      value: password,
                      onChange: event => this.setPasswords(event),

                      startAdornment: (
                        <InputAdornment
                          position="start"
                          className={classes.inputAdornment}>
                          <BookmarkBorder className={classes.inputAdornmentIcon} />
                        </InputAdornment>
                      )
                    }}
                  />


                </GridItem>

                {/* Nueva Contraseña */}
                {/* Generate Password Input */}
                <GridItem xs={12} sm={12}>


                  <CustomInput
                    labelText={
                      <span>
                        Nueva Contraseña
                        </span>
                    }
                    type={"password"}

                    id="newPassword"
                    formControlProps={{
                      fullWidth: true
                    }}

                    inputProps={{

                      name: "newPassword",
                      id: "newPassword",

                      value: newPassword,
                      onChange: event => this.setPasswords(event),

                      startAdornment: (
                        <InputAdornment
                          position="start"
                          className={classes.inputAdornment}>
                          <BookmarkBorder className={classes.inputAdornmentIcon} />
                        </InputAdornment>
                      )
                    }}

                  />


                </GridItem>

                <GridItem xs={12} sm={12}>


                  <CustomInput
                    labelText={
                      <span>
                        Confirmar Contraseña
                        </span>
                    }
                    type={"password"}

                    id="confirmPassword"
                    
                    formControlProps={{
                      fullWidth: true
                    }}
                    
                    inputProps={{

                      name: "confirmPassword",
                      id: "confirmPassword",

                      value: confirmPassword,
                      onChange: event => this.setPasswords(event),

                      startAdornment: (
                        <InputAdornment
                          position="start"
                          className={classes.inputAdornment}>
                          <BookmarkBorder className={classes.inputAdornmentIcon} />
                        </InputAdornment>
                      )
                    }}

                  />


                </GridItem>


                {typeNewness.id > 0 &&
                  <GridItem xs={12} sm={12}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checkedIcon={
                            <Check className={classes.checkedIcon} />
                          }
                          icon={<Check className={classes.uncheckedIcon} />}
                          classes={{
                            checked: classes.checked
                          }}
                          checked={typeNewness.active}
                          onClick={() => this.handleToggle()}
                          disableRipple
                        />
                      }
                      label={"Activo"}>
                    </FormControlLabel>
                  </GridItem>
                }

              </GridItem>


              <GridItem xs={12} sm={12} className={classes.gridItem}>

                <Button
                  onClick={this.changePassword}
                  color="success"
                  round><SaveIcon />
                  Guardar
                </Button>

              </GridItem>

            </GridContainer>
          </CardBody>
        </Card>
      </GridItem>
    );
  }

}

const mapStateToProps = state => {
  return {
    typeNewnessState: state.typeNewnessState,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    configureTypeNewness: (typeNewness, ownProps, onSuccess) => dispatch(configureTypeNewness(typeNewness, ownProps, onSuccess)),
    setTypeNewness: (typeNewness) => dispatch(setTypeNewness(typeNewness)),
    getTypeNewnessById: (id) => dispatch(getTypeNewnessById(id)),
  };
};

export default withStyles(style)(connect(mapStateToProps, mapDispatchToProps)(ChangePasswordAdmin));